import React from 'react';
import PageSection from 'components/PageSection';
import { useAPI } from 'api';
import DataTable from 'components/DataTable';
import { Category } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

export default function WorkspaceCategorySettings() {
	const api = useAPI();

	const ctx = useOrgContext();

	const [workspaceCategories, setWorkspaceCategories] = React.useState<Category[]>([]);
	const [selectedCategories, setSelectedCategories] = React.useState<Category[]>([]);

	const loadWorkspaceCategories = () => {
		api.get<Category[]>(`${ctx?.apiBaseWorkspace}/overrides/firewall/categories`)
		.then(json => setWorkspaceCategories(json));
	};

	const selectCategory = (category: Category) => {
		setSelectedCategories([...selectedCategories, category]);
	};

	const deselectCategory = (category: Category) => {
		setSelectedCategories(selectedCategories.filter(c => c.id !== category.id));
	};

	const makeSelectedCategoriesAvailable = () => {
		api.put(`${ctx?.apiBaseWorkspace}/overrides/firewall/categories/availability`, selectedCategories.reduce((acc, category) => ({ ...acc, [category.id]: 'available' }), {}))
		.then(() => loadWorkspaceCategories());
	};

	const makeSelectedCategoriesUnavailable = () => {
		api.put(`${ctx?.apiBaseWorkspace}/overrides/firewall/categories/availability`, selectedCategories.reduce((acc, category) => ({ ...acc, [category.id]: 'unavailable' }), {}))
		.then(() => loadWorkspaceCategories());
	};

	React.useEffect(() => {
		loadWorkspaceCategories();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<PageSection level={3} title="Categories">
				<p>Categories for workspace '{ctx?.workspace?.name}'</p>

				<p>
					<button onClick={makeSelectedCategoriesAvailable}>Make Selected Available</button>
					<button onClick={makeSelectedCategoriesUnavailable}>Make Selected Unavailable</button>
				</p>

				<DataTable<Category>
					columns={[
						{
							label: '',
							key: 'id',
							render: (category) => <input type="checkbox" checked={selectedCategories.some(c => c.id === category.id)} onChange={() => selectedCategories.some(c => c.id === category.id) ? deselectCategory(category) : selectCategory(category)} />
						},
						{ label: 'ID', key: 'id' },
						{ label: 'Name', key: 'name' },
						{ label: 'Productivity', key: 'productivity' },
						{ label: 'Availability', key: 'availability' },
					]}
					data={workspaceCategories}
				/>

			</PageSection>
		</div>
	);
}
